
<template>
  <div>
    <Header />
    <v-container>
      <v-row justify="center" align="center" fill-height>
        <v-col cols="12" xl="8">
          <v-alert type="error" v-if="error">{{error}}</v-alert>
          <v-card :loading="loading">
            <v-container>
              <v-card-title>Neuer Nutzer</v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col>
                      <p>Füllen Sie bitte alle Felder aus, um einen neuen Benutzer hinzuzufügen.</p>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-card>
                        <v-card-text>
                          Neuer Benutzer
                          <h3 class="headline">Bitte füllen Sie alle Felder aus</h3>
                          <v-text-field
                            class="pt-5"
                            autofocus
                            placeholder="Name"
                            outlined
                            label="Username"
                            v-model="user.name"
                          ></v-text-field>

                          <v-text-field
                            placeholder="Password"
                            outlined
                            label="Password"
                            v-model="user.password"
                            @click:append="generatePassword"
                            append-icon="mdi-wrench"
                          ></v-text-field>

                          <v-text-field
                            placeholder="E-Mail"
                            outlined
                            label="E-Mail Adresse"
                            v-model="user.email"
                          ></v-text-field>
                        </v-card-text>

                        <v-card-actions class="justify-center">
                          <v-btn
                            large
                            color="primary"
                            @click="create"
                          >WEITER</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-col>
                    <v-col>
                      <v-card>
                        <v-card-text>
                          <h3 class="headline">Wähle den dazugehörigen Kunden aus</h3>
                          <v-select :items="customers" v-model="user.customerId" item-value="id" item-text="name" label="Kunde auswählen" class="pt-5" solo>
                            
                          </v-select>
                          {{user.customerId}}
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Header from "@/views/general/header";
import router from "@/plugins/router";

import UserService from "@/services/UserService";
import CustomersSerivce from "@/services/CustomerService";
import AppListItem from "@/views/apps/components/AppListItem";
import AddNewApp from "@/views/apps/components/AddNewApp";
import ColorField from "@/views/general/components/ColorPicker";

export default {
  name: "dashboard",
  components: {
    Header: Header,
    AppListItem: AppListItem,
    AddNewApp: AddNewApp,
    "v-color-field": ColorField
  },
  data: () => ({
    loading: true,
    error: null,
    customers: null,
    user: {
      appId: null,
      customerId: null,
      name: null,
      password: null,
      email: null
    }
  }),
  mounted() {
    this.refresh();
  },
  methods: {
    generatePassword() {
      this.user.password = "xxxxxxxxxxxx4xxxyxxx".replace(/[xy]/g, function(c) {
        var r = (Math.random() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });

      return true;
    },
    async create() {
      try {
        this.loading = true;

        //add user
        try {
          let payload = this.user;
          let response = await UserService.add(this.$route.params.id, payload)
        } catch(err) {
          alert(err.message)
        }

        this.loading = false;
        router.push({ name: "Users", params: {id: this.$route.params.id } });
      } catch (err) {
        this.loading = false;
        this.error = err.message;
      }
    },
    async refresh() {
      this.loading = true;
      try {
        this.customers = (await CustomersSerivce.get(this.$route.params.id)).data

        this.loading = false;
      } catch (err) {
        if (err.response.status == 401) {
          router.replace("/auth/login");
        }
      }
    }
  }
};
</script>

